import axios from 'axios';
import { AUTH_BASE_URL, BASE_URL } from '../redux/actions/dashboard/env.variables';
import store from '../redux/store';
import {login, logout} from '../redux/actions/auth.actions';

let requestsToRefresh: ((token: string) => void)[] = []

let isRefreshRequesting = false

export const axiosJWTInstance = axios.create({
    baseURL: `${BASE_URL}/api`,
    headers: { 'Cache-Control': 'no-cache' },
});


const requestHandler = (request: any) => {
    request.headers['Authorization'] = 'Bearer ' + store.getState().auth.user?.token;
    localStorage.setItem("Authorization", request.headers['Authorization']);
    return request;
};

export const errorHandler = (error: any) => {    
    const { response, config } = error
    let isLoggedIn = store.getState().auth &&  store.getState().auth.user;

    if (response.status === 401) {
        // If we have not logged in before, it makes no sense
        // to try to get a new token
        if (!isLoggedIn) {
          return Promise.reject(error)
        }
  
        // User is auth, probably token is expired, try renew
        // And send all failed requests again
        if (!isRefreshRequesting) {
          isRefreshRequesting = true
  
          console.log('Request for a new token')
  
          // Send request to refresh token
          axios
            .post(`${AUTH_BASE_URL}/Api/Account/RefreshToken`, null, {
                headers: {
                "Access-Control-Allow-Origin": "*",
                "content-type": "application/json",
                },
                data: { refreshToken: store.getState().auth.user?.refreshToken },
            })
            .then(({ data }) => {
                console.log('New token received');
                store.dispatch(login(data.token, data.refreshToken));
                requestsToRefresh.forEach((cb) => cb(data.token))
            })
            .catch((err) => {
                console.log('An error occurred while getting a new token')
                store.dispatch(logout());
            })
            .finally(() => {
                console.log('Clear queue of failed requests')
                requestsToRefresh = []
                isRefreshRequesting = false
            })
        }

        console.log(`The request is waiting for a new token.. [${response.config.url}]`)

        return new Promise((resolve, reject) => {
            requestsToRefresh.push((token) => {
                if (token) {
                    resolve(axiosJWTInstance(config));
                }
                
                reject(Promise.reject(error));
            });
        });
    }

    return Promise.reject(error)
};

export const successHandler = (response: any) => {
    // Handle responses
    return response;
};

axiosJWTInstance.interceptors.request.use(
    request => requestHandler(request),
);
axiosJWTInstance.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error),
);